import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Temperature"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9.75038 12.945V4.5C9.75038 2.84315 8.40724 1.5 6.75038 1.5C5.09353 1.5 3.75038 2.84315 3.75038 4.5V12.945C1.86791 14.2558 1.05439 16.637 1.74131 18.8256C2.42822 21.0142 4.45651 22.5034 6.75038 22.5034C9.04426 22.5034 11.0725 21.0142 11.7595 18.8256C12.4464 16.637 11.6329 14.2558 9.75038 12.945ZM6.75027 3C7.57869 3 8.25027 3.67157 8.25027 4.5V9.75H5.25027V4.5C5.25027 3.67157 5.92184 3 6.75027 3ZM6.75045 21C5.05325 20.9999 3.56767 19.86 3.1284 18.2206C2.68913 16.5812 3.40567 14.8512 4.87545 14.0025L5.25045 13.7925V11.25H8.25045V13.7925L8.62545 14.0025C10.0952 14.8512 10.8118 16.5812 10.3725 18.2206C9.93323 19.86 8.44766 20.9999 6.75045 21ZM15.0003 3H22.5003V4.5H15.0003V3ZM15.0003 7.5H20.2503V9H15.0003V7.5ZM15.0003 12H22.5003V13.5H15.0003V12ZM15.0003 16.5H20.2503V18H15.0003V16.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Temperature.vue"]]);
